import { render, staticRenderFns } from "./Countries.vue?vue&type=template&id=85d3c51a&"
import script from "./Countries.vue?vue&type=script&lang=js&"
export * from "./Countries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85d3c51a')) {
      api.createRecord('85d3c51a', component.options)
    } else {
      api.reload('85d3c51a', component.options)
    }
    module.hot.accept("./Countries.vue?vue&type=template&id=85d3c51a&", function () {
      api.rerender('85d3c51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/Countries.vue"
export default component.exports